import { deepClone } from "./objectUtilities";

const copy = data => deepClone(data);

export function htmlToText(html) {
    html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
    html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
    html = html.replace(/<\/div>/ig, '\n');
    html = html.replace(/<\/li>/ig, '\n');
    html = html.replace(/<li>/ig, '  *  ');
    html = html.replace(/<\/ul>/ig, '\n');
    html = html.replace(/<\/p>/ig, '\n');
    html = html.replace(/<br\s*[/]?>/gi, "\n");
    html = html.replace(/<[^>]+>/ig, '');
    return html;
}

export function processTemplate(content, context) {
    content = content.replace(/\+\+\+\s+FOR\s+(\w+)\s+IN\s+([a-zA-Z0-9_.]+)\s+\+\+\+([\s\S]*)\+\+\+\s+END-FOR\s+\1\s+\+\+\+/g, function (match, p1, p2, p3, offset, str) {
        let innerContext = copy(context);
        let parts = p2.split('.');
        let list = context[parts[0]];
        for (let i = 1; list && i < parts.length; ++i) {
            list = list[parts[i]];
        }
        let toReturn = '';
        for (let i = 0; list && i < list.length; ++i) {
            innerContext[p1] = list[i];
            toReturn += processTemplate(p3, innerContext);
        }
        return toReturn;
    });
    content = content.replace(/\+\+\+\s+FOR\s+(\w+),\s+(\w+)\s+IN\s+([a-zA-Z0-9_.]+)\s+\+\+\+([\s\S]*)\+\+\+\s+END-FOR\s+\1\s+\+\+\+/g, function (match, p1, p2, p3, p4, offset, str) {
        let innerContext = copy(context);
        let parts = p3.split('.');
        let list = context[parts[0]];
        for (let i = 1; list && i < parts.length; ++i) {
            list = list[parts[i]];
        }
        let toReturn = '';
        for (let i = 0; list && i < list.length; ++i) {
            innerContext[p1] = list[i];
            innerContext[p2] = i;
            toReturn += processTemplate(p4, innerContext);
        }
        return toReturn;
    });
    content = content.replace(/\+\+\+\s+IF\s+(\w+)\s+=\s+([a-zA-Z0-9_.]+)\s+\+\+\+([\s\S]*)\+\+\+\s+ELSE\s+\+\+\+([\s\S]*)\+\+\+\s+END-IF\s+\1\s+\+\+\+/g, function (match, p1, p2, p3, p4, offset, str) {
        let innerContext = copy(context);
        let parts = p2.split('.');
        let list = context[parts[0]];
        for (let i = 1; list && i < parts.length; ++i) {
            list = list[parts[i]];
        }
        let toReturn = '';
        if (list) {
            innerContext[p1] = list;
            toReturn += processTemplate(p3, innerContext);
        } else {
            innerContext[p1] = list;
            toReturn += processTemplate(p4, innerContext);
        }
        return toReturn;
    });
    content = content.replace(/\+\+\+\s+IF\s+(\w+)\s+=\s+([a-zA-Z0-9_.]+)\s+%\s+(\d+)\s+==\s+(\d+)\s+\+\+\+([\s\S]*)\+\+\+\s+END-IF\s+\1\s+\+\+\+/g, function (match, p1, p2, p3, p4, p5, offset, str) {
        let innerContext = copy(context);
        let parts = p2.split('.');
        let list = context[parts[0]];
        for (let i = 1; list && i < parts.length; ++i) {
            list = list[parts[i]];
        }
        list = (parseInt(list) % parseInt(p3)) == parseInt(p4);
        let toReturn = '';
        if (list) {
            innerContext[p1] = list;
            toReturn += processTemplate(p5, innerContext);
        }
        return toReturn;
    });
    content = content.replace(/\+\+\+\s+IF\s+(\w+)\s+=\s+([a-zA-Z0-9_.]+)\s+\+\+\+([\s\S]*)\+\+\+\s+END-IF\s+\1\s+\+\+\+/g, function (match, p1, p2, p3, offset, str) {
        let innerContext = copy(context);
        let parts = p2.split('.');
        let list = context[parts[0]];
        for (let i = 1; list && i < parts.length; ++i) {
            list = list[parts[i]];
        }
        let toReturn = '';
        if (list) {
            innerContext[p1] = list;
            toReturn += processTemplate(p3, innerContext);
        }
        return toReturn;
    });
    content = content.replace(/\+\+\+=[^+]*\+\+\+/g, function (match) {
        match = match.slice(4).slice(0, -3);
        match = match.trim();
        if (match) {
            let parts = match.split('.');
            let value = context[parts[0]];
            for (let i = 1; value && i < parts.length; ++i) {
                value = value[parts[i]];
            }
            return value ? value.toString() : '-';
        } else {
            return '-';
        }
    });
    return content;
}